import React from "react"
import "./reset.css"
import "./global.css"

export default ({ children }) => <div>{children}</div>
